import { TransportType } from "@boxem/core-api-schema";

import styles from "./PageHeader.module.css";

import IconCheck from "@/components/icons/IconCheck";
import Button from "@/components/forms/Button/Button";
import IconArrow from "@/components/icons/IconArrow";
import { Tooltip } from "@/components/Tooltip/Tooltip";

import { ContinueButtonState } from "../FbaShipmentFlow";

const SHIPMENT_TYPE_STEPS = {
  [TransportType.SPD]: [ "Choose products", "Prep & Boxem®", "Confirm Shipments" ],
  [TransportType.LTL]: [ "Choose products", "Confirm Shipments", "Prep & Boxem®", "Review & Ship" ],
}

export type PageHeaderProps = {
  step: number;
  subSteps?: { cur: number, total: number }[];
  shipmentType: TransportType;
  continueButton: ContinueButtonState;
  onContinueClicked: () => void;
  onCancelClicked?: () => void;
};

export default function PageHeader(props: PageHeaderProps) {
  const {
    step,
    subSteps,
    shipmentType,
    continueButton,
    onContinueClicked,
    onCancelClicked,
  } = props;

  const maxStep = shipmentType === TransportType.LTL ? 3 : 2;
  if (step > maxStep) {
    console.error(`invalid step set in component: ${step}`);
    return null;
  }

  function renderSteps() {
    let steps = SHIPMENT_TYPE_STEPS[shipmentType];

    const className = index => index < step
      ? styles.stepPrev : index === step
      ? styles.stepActive
      : styles.stepNext;

    return (
      <div className={styles.stepsContainer}>
        {steps.map((stepText, index) => {
          const fullText = `${stepText}${subSteps?.[index] ? ` (${subSteps[index].cur}/${subSteps[index].total})` : ""}`;
          return <div style={{display: 'contents'}} key={index}>
            <div className={`${styles.stepItem} ${className(index)} strong`}>
              <div className={styles.stepNumber}>
                {index < step
                  ? <IconCheck className={styles.stepIcon} size={20} />
                  : <span className={styles.stepIcon}>{index + 1}</span>
                }
              </div>
              <Tooltip title={fullText}>
                <div style={{textOverflow: "ellipsis", overflow: "hidden"}}>
                  {stepText}
                  {subSteps?.[index] && <span style={{fontWeight: "normal"}}>&nbsp;({subSteps[index].cur}/{subSteps[index].total})</span>}
                </div>
              </Tooltip>
            </div>
            { index + 1 < steps.length && <span className={styles.spacer} /> }
          </div>
        })}
      </div>
    );
  }

  return (
    <div className={styles.header}>
      {renderSteps()}
      <div className={styles.actionButtons}>
        {onCancelClicked && <Button type="danger" onClick={onCancelClicked}>Cancel Shipment</Button>}
        <Tooltip title={continueButton.reason} delayMs={0}>
          <Button
            type="primary"
            disabled={continueButton.disabled}
            onClick={onContinueClicked}
          >
            Continue <IconArrow size={26} className={styles.arrow}/>
          </Button>
        </Tooltip>
      </div>
    </div>
  );
}
